import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getDownloadPengurusProvinsi,
  getDownloadPengurusPusat,
} from "../../../config/Redux/Download/actions";
import DownloadIcon from "@mui/icons-material/Download";
import CloseIcon from "@mui/icons-material/Close"; // Fixed Import

export default function BasicTable(param) {
  const dispatch = useDispatch();

  const dataDetail = useSelector((state) => state.download);
  // dataDetail?.downloadPengurusProvinsi?.data?.sort((a, b) => a?.data_diri?.id_jabatan > b?.data_diri?.id_jabatan ? 1 : -1);
  dataDetail?.downloadPengurusProvinsi?.data?.sort(function (a, b) {
    if (a?.tingkat_exco?.id_provinsi === b?.tingkat_exco?.id_provinsi) {
      return a.data_diri?.id_jabatan - b.data_diri?.id_jabatan;
    }
    return a?.tingkat_exco?.id_provinsi > b?.tingkat_exco?.id_provinsi ? 1 : -1;
  });

  let ketum = "";
  let sekjen = "";
  dataDetail?.downloadPengurusPusat?.data?.map((a) => {
    if (a?.data_diri?.id_jabatan === 7) {
      ketum = a?.data_diri?.nama;
    }
    if (a?.data_diri?.id_jabatan === 9) {
      sekjen = a?.data_diri?.nama;
    }
    return a;
  });
  // console.log(dataDetail)
  useEffect(() => {
    dispatch(getDownloadPengurusProvinsi("", "", ""));
    dispatch(getDownloadPengurusPusat());
  }, [dispatch]);

  const convertDate = (time) => {
    let date = new Date(time);
    let month = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember",
    ];
    return `${(date.getDate() < 10 ? "0" : "") + date.getDate()} ${
      month[date.getMonth()]
    } ${date.getFullYear()}`;
  };

  const exportToWord = async (element, filename) => {
    let css =
      "<style>@page download-paper{size: 8.27in 11.69in;mso-page-orientation: portrait;margin:0.75in 0.50in 0.75in 0.50in;}div.download-paper {page: download-paper;}</style>";
    var preHtml =
      "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>Export HTML To Doc</title>" +
      css +
      "</head><body>";
    var postHtml = "</body></html>";
    var html = preHtml + document.getElementById(element).innerHTML + postHtml;
    // console.log(html);

    var blob = new Blob(["\ufeff", html], {
      type: "application/msword",
    });

    // Specify link url
    var url =
      "data:application/vnd.ms-word;charset=utf-8," + encodeURIComponent(html);

    // Specify file name
    filename = filename ? filename + ".doc" : "document.doc";

    // Create download link element
    var downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = url;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }

    document.body.removeChild(downloadLink);
  };

  let alphabet = "abcdefghijklmnopqrstuvwxyz".split("");
  let temp = 0;
  // let tempidx=0;
  let tempCount = 0;

  return (
    <>
      <div className="download-page">
        {/* Premium Header - Dark Blue Gradient */}
        <div
          id="premium-download-header"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "20px 32px",
            background: "linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
            position: "sticky",
            top: 0,
            zIndex: 100,
          }}
        >
          {/* Left - Title */}
          <div>
            <h2
              style={{
                fontSize: 20,
                fontWeight: 700,
                color: "#ffffff",
                margin: 0,
                letterSpacing: "0.5px",
              }}
            >
              Susunan Pengurus Tingkat Provinsi
            </h2>
            <p
              style={{
                fontSize: 13,
                color: "rgba(255, 255, 255, 0.7)",
                margin: "6px 0 0",
                fontWeight: 400,
              }}
            >
              Partai Buruh
            </p>
          </div>

          {/* Right - Action Buttons */}
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <button
              onClick={() =>
                exportToWord("download-paper", "Pengurus Provinsi")
              }
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: 8,
                padding: "10px 20px",
                backgroundColor: "#4caf50",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                transition: "all 0.2s ease",
                color: "#ffffff",
                fontSize: 14,
                fontWeight: 600,
                boxShadow: "0 2px 8px rgba(76, 175, 80, 0.3)",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#43a047";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#4caf50";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <DownloadIcon style={{ fontSize: 20 }} />
              Download
            </button>

            <button
              onClick={() => param.setOpenDownload(false)}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 44,
                height: 44,
                backgroundColor: "rgba(255, 255, 255, 0.1)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: 12,
                cursor: "pointer",
                transition: "all 0.2s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(255, 255, 255, 0.2)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.4)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor =
                  "rgba(255, 255, 255, 0.1)";
                e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
              }}
            >
              <CloseIcon style={{ fontSize: 22, color: "#ffffff" }} />
            </button>
          </div>
        </div>
        <div id="download-paper">
          <div className="download-paper">
            <div style={{ textAlign: "center" }}>
              PARTAI POLITIK TINGKAT PUSAT <br />
              PARTAI BURUH
            </div>
            <br />
            <div style={{ textAlign: "center" }}>
              DAFTAR SUSUNAN PENGURUS DAN ALAMAT KANTOR TETAP <br />
              PARTAI POLITIK TINGKAT PROVINSI
            </div>
            <br />
            <br />
            <div className="download-table" style={{ width: "100%" }}>
              <table
                frame="border"
                cellSpacing="0"
                cellPadding="0"
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  border: "1px solid black",
                }}
              >
                <thead>
                  <tr style={{ textAlign: "center" }}>
                    <td style={{ padding: "4px", border: "1px solid black" }}>
                      NO.
                    </td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>
                      SUSUNAN PENGURUS
                    </td>
                    <td
                      style={{
                        padding: "4px",
                        border: "1px solid black",
                        maxWidth: "35mm",
                      }}
                    >
                      NAMA
                    </td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>
                      NO. KARTU TANDA ANGGOTA
                    </td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>
                      NIK
                    </td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>
                      NOMOR SURAT KEPUTUSAN
                    </td>
                    <td style={{ padding: "4px", border: "1px solid black" }}>
                      ALAMAT KANTOR
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {dataDetail?.downloadPengurusProvinsi?.data?.map(
                    (list, idx, arr) => {
                      const prevValue = arr[idx - 1];
                      let arrData = [];
                      let flag = false;
                      if (
                        prevValue?.tingkat_exco?.id_provinsi !==
                        list?.tingkat_exco?.id_provinsi
                      ) {
                        tempCount = 0;
                        temp = 0;
                        // tempHtml = null;
                        flag = true;
                        // tempidx = idx;
                        arrData = arr.filter(function (el) {
                          return (
                            el?.tingkat_exco?.id_provinsi ===
                            list?.tingkat_exco?.id_provinsi
                          );
                        });
                        // console.log(arrData);
                      }
                      if (
                        prevValue?.data_diri?.id_jabatan !==
                        list?.data_diri?.id_jabatan
                      ) {
                        // console.log("current",list?.data_diri?.id_jabatan);
                        temp++;
                      }
                      tempCount++;
                      return (
                        <tr key={idx}>
                          {flag ? (
                            <>
                              <td
                                rowSpan={arrData.length}
                                style={{
                                  padding: "4px",
                                  borderRight: "1px solid black",
                                  borderBottom: "1px solid black",
                                  textAlign: "center",
                                }}
                              >
                                {idx + 1}
                              </td>
                            </>
                          ) : null}
                          <td
                            style={{
                              padding: "4px",
                              borderRight: "1px solid black",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {alphabet[temp - 1]}.{" "}
                            {list?.data_diri?.nama_jabatan}
                          </td>
                          <td
                            style={{
                              padding: "4px",
                              borderRight: "1px solid black",
                              borderBottom: "1px solid black",
                              maxWidth: "35mm",
                            }}
                          >
                            {list?.data_diri?.nama.toUpperCase()}
                          </td>
                          <td
                            style={{
                              padding: "4px",
                              borderRight: "1px solid black",
                              borderBottom: "1px solid black",
                              textAlign: "center",
                            }}
                          >
                            {list?.data_diri?.no_kta}
                          </td>
                          <td
                            style={{
                              padding: "4px",
                              borderRight: "1px solid black",
                              borderBottom: "1px solid black",
                            }}
                          >
                            {list?.data_diri?.nik}
                          </td>
                          {flag ? (
                            <>
                              <td
                                rowSpan={arrData.length}
                                style={{
                                  padding: "4px",
                                  borderRight: "1px solid black",
                                  borderBottom: "1px solid black",
                                  maxWidth: "25mm",
                                  overflow: "hidden",
                                  wordWrap: "break-word",
                                }}
                              >
                                {list?.tingkat_exco?.nomor_sk}
                                <br />
                                Tanggal : {list?.tingkat_exco?.tanggal_sk}
                              </td>
                              <td
                                rowSpan={arrData.length}
                                style={{
                                  padding: "4px",
                                  borderRight: "1px solid black",
                                  borderBottom: "1px solid black",
                                }}
                              >
                                {list?.data_diri?.alamat_kantor}
                              </td>
                            </>
                          ) : null}
                        </tr>
                      );
                    },
                  )}
                </tbody>
              </table>
            </div>
            <br />
            <br />
            <div style={{ textAlign: "right" }}>
              Jakarta, {convertDate(new Date())}
            </div>
            <br />
            <div style={{ textAlign: "center" }}>
              PIMPINAN PARTAI POLITIK TINGKAT PUSAT
              <br />
              PARTAI BURUH
            </div>
            <br />
            <br />
            <div style={{ textAlign: "center" }}>
              <table style={{ width: "100%", textAlign: "center" }}>
                <tbody>
                  <tr>
                    <td style={{ width: "50%", textAlign: "center" }}>
                      Presiden
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      {ketum}
                    </td>
                    <td style={{ width: "50%", textAlign: "center" }}>
                      Sekretaris Jenderal
                      <br />
                      <br />
                      <br />
                      <br />
                      <br />
                      {sekjen}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
